import React, { useEffect, useRef, useState } from "react";
import { authtockencallApi } from "../../../common/API/Api";
import { useTranslation } from "react-i18next";
import { useNotification } from "../../../common/Notification";
import compreface from "./compreface";
import user from "../../../../images/user.png";
import { QRCodeCanvas } from "qrcode.react";
import { useSearchParams } from "react-router-dom";
const Userverify = () => {
  const [searchParams] = useSearchParams();
  const { t, i18n } = useTranslation();
  const [qrUrl, setQrUrl] = useState("");
  const [userdata, setUserdata] = useState(null);
  const [showvarification, setShowvarification] = useState();
  const [cameraAvailable, setCameraAvailable] = useState(null);
  const [capturedImage, setCapturedImage] = useState(null);
  const [checkopencamara, setCheckopencamara] = useState(false);
  const [verificationResult, setVerificationResult] = useState(null);
  const { showNotification } = useNotification();
  const [error, setError] = useState("");
  const streamRef = useRef(null);
  const canvasRef = useRef(null);
  const videoRef = useRef(null);
  const [authtoken, setAuthtoken] = useState("");
  const [imageloader, setImageloader] = useState({
    loading1: false,
    loading2: false,
  });
  const token = searchParams.get("token");
  const decompressToken = async (token) => {
    let base64 = token.replace(/-/g, "+").replace(/_/g, "/");

    while (base64.length % 4) {
      base64 += "=";
    }

    const binary = atob(base64);

    const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));

    const stream = new DecompressionStream("deflate");

    const writer = stream.writable.getWriter();

    writer.write(bytes);
    writer.close();

    const decompressed = await new Response(stream.readable).arrayBuffer();

    return new TextDecoder().decode(decompressed);
  };
  // useEffect(() => {
  //   const getToken = async () => {
  //     try {
  //       const jwt = await decompressToken(token);

  //       setAuthtoken(jwt);
  //     } catch (error) {
  //       console.error("Failed to decompress token:", error);
  //     }
  //   };

  //   if (token) {
  //     getToken();
  //   }
  // }, [token]);

  const userdetails = async (loading) => {
    try {
      let res = await authtockencallApi(
        {},
        `api/userdetail?type=real`,
        "GET",
        token,
      );
      if (res?.data?.success !== false) {
        let updateddata = { ...res?.data?.data?.user };
        if (
          updateddata?.name &&
          !updateddata.first_name &&
          !updateddata.last_name
        ) {
          const parts = updateddata.name.trim().split(/\s+/);
          if (parts.length === 2 && !isNaN(parts[1])) {
            updateddata.last_name = "";
            updateddata.first_name = "";
          } else {
            if (parts.length >= 3) {
              updateddata.last_name = parts[2];
              updateddata.first_name = parts[0] + " " + parts[1] || "";
            } else {
              updateddata.first_name = parts[0] || "";
              updateddata.last_name = parts[1] || "";
            }
          }
        }
        updateddata.country = {
          value: res?.data?.data?.user?.country,
          label: res?.data?.data?.user?.countryName,
        };
        setUserdata(updateddata);
        let userdata = res?.data?.data?.user;
        if (
          userdata?.identity_status === 1 ||
          userdata?.identity_status === 2
        ) {
          setShowvarification(true);
        } else {
          setShowvarification(false);
        }
        //  let userdoc = JSON.parse(updateddata?.document_types);
        //  getuserdocumentlist(userdoc);
      } else {
        console.error("API error:", res.error);
        setShowvarification(false);
      }
    } catch (err) {
      console.log(err, "error");
    }
  };
  useEffect(() => {
    const checkCamera = async () => {
      try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const hasVideoInput = devices.some(
          (device) => device.kind === "videoinput",
        );
        setCameraAvailable(hasVideoInput);
      } catch (err) {
        setCameraAvailable(false);
        setError("Error accessing media devices.");
      }
    };
    checkCamera();
  }, []);
  const startCamera = async () => {
    setError("");
    setCapturedImage(null);
    setVerificationResult(null);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      streamRef.current = stream;
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        videoRef.current.play();
      }
      setCheckopencamara(true);
    } catch (err) {
      setError("Unable to access the camera.");
    }
  };

  const capturePhoto = async () => {
    if (!videoRef.current || !canvasRef.current) return;
    setImageloader((state) => ({
      ...state,
      loading2: true,
    }));
    const width = videoRef.current.videoWidth;
    const height = videoRef.current.videoHeight;
    canvasRef.current.width = width;
    canvasRef.current.height = height;
    const ctx = canvasRef.current.getContext("2d");
    ctx.drawImage(videoRef.current, 0, 0, width, height);
    const imageData = canvasRef.current.toDataURL("image/jpeg");
    setCapturedImage(imageData);

    if (userdata?.user_source) {
      const blob = await base64ToBlob(imageData);
      const file = await blobToFile(blob, "image.png");
      uploadimage(file, "user_target");
      verifyFace(imageData, userdata?.user_source);
    }
  };
  const uploadimage = async (image, type) => {
    if (type === "user_source") {
      setImageloader((state) => ({
        ...state,
        loading1: true,
      }));
    }
    let file;
    if (type === "user_target") {
      file = image;
    } else if (type === "user_source") {
      file = image.target.files[0];
    } else {
      if (image === null) {
        file = null;
      } else {
        file = image;
      }
    }
    let obj = { image: file, type: type };
    // const processToastId = showProcessToast("Loading data... Please wait.");
    try {
      const formData = new FormData();
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          formData.append(key, obj[key]);
        }
      }
      let postdata = formData;
      let res = await authtockencallApi(
        postdata,
        `api/setimage`,
        "POST",
        token,
      );
      if (res?.data?.success) {
        // updateToastMessage(processToastId, res?.data?.message, "success");
        showNotification(res?.data?.message, "success");
        if (type === "user_target") {
          setUserdata((state) => ({
            ...state,
            user_target: file,
          }));
        } else {
          setImageloader((state) => ({
            ...state,
            loading1: false,
          }));
          setUserdata((state) => ({
            ...state,
            user_source: file,
          }));
        }
      } else {
        showNotification(res?.data?.message, "error");
        // updateToastMessage(processToastId, res?.data?.message, "error");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const verifyFace = async (capturedBase64, uploadedFile) => {
    setVerificationResult(null);
    try {
      const formData = new FormData();
      const byteString = atob(capturedBase64.split(",")[1]);
      const mimeString = capturedBase64
        .split(",")[0]
        .split(":")[1]
        .split(";")[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([ab], { type: mimeString });
      let uploadedimg = uploadedFile;
      // let capturedimg = capturedBase64;
      console.log(capturedBase64, uploadedFile, "capturedBase64");
      formData.append("source_image", uploadedimg);
      // formData.append("target_image", capturedimg); // captured selfie
      formData.append("target_image", blob, "captured.jpg");
      const response = await compreface.post("/verify", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.result && response.data.result.length > 0) {
        const result = response.data.result[0]?.face_matches[0];
        setVerificationResult({
          similarity: result.similarity,
          verified: result.similarity >= 0.9 ? true : false,
        });
        setImageloader((state) => ({
          ...state,
          loading2: false,
        }));
        if (result.similarity >= 0.9) {
          identifyuser();
        }
      } else {
        setVerificationResult({ error: t("No face matched.") });
      }
    } catch (err) {
      console.error("Verification error:", err);
      setVerificationResult({ error: t("Verification Pending.") });
    }
  };
  function blobToFile(blob, fileName) {
    return new File([blob], fileName, { type: blob.type });
  }
  function base64ToBlob(base64Data, contentType = "image/png") {
    const byteCharacters = atob(base64Data.split(",")[1]);
    const byteArrays = [];
    for (let i = 0; i < byteCharacters.length; i++) {
      byteArrays.push(byteCharacters.charCodeAt(i));
    }
    const byteArray = new Uint8Array(byteArrays);
    return new Blob([byteArray], { type: contentType });
  }
  useEffect(() => {
    return () => {
      if (streamRef.current) {
        streamRef.current.getTracks().forEach((track) => track.stop());
      }
    };
  }, []);
  const identifyuser = async () => {
    try {
      let postdata = { identity_status: 1 };
      const formData = new FormData();
      for (let key in postdata) {
        if (postdata.hasOwnProperty(key)) {
          formData.append(key, postdata[key]);
        }
      }
      let res = await authtockencallApi(
        formData,
        `api/sumsub/status`,
        "POST",
        token,
      );
      if (res?.data?.success) {
        // console.log(res?.data?.success, "res?.data?.success");
        showNotification(res?.data?.message, "success");
        userdetails();
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    if (token) {
      userdetails();
    }
  }, [token]);

  return (
    <div className="DocumentsVerificationSection">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="cardBox">
              <h4 className="card_title">
                {t("Documents Verification")}
                {userdata?.identity_status === 1 ? (
                  <span className="badge bg-success d-inline-flex ms-2">
                    {t("Verified")}
                  </span>
                ) : userdata?.identity_status === 2 ? (
                  <span className="badge status-underconsideration d-inline-flex ms-2">
                    {t("Under Review")}
                  </span>
                ) : userdata?.identity_status === 3 ? (
                  <span className="badge status-failed d-inline-flex ms-2">
                    {t("Declined")}
                  </span>
                ) : (
                  ""
                )}
              </h4>

             {showvarification === false ? ( 
                <>
                {cameraAvailable === null ? (
                    <p>{t("Checking for camera")}...</p>
                  ) : cameraAvailable ? ( 
                    userdata?.user_source && userdata?.user_target ? (
                      <>
                        <p style={{ color: "yellow" }}>
                          Verification is pending. Please wait for the confirmation
                          email.
                        </p>
                      </>
                    ) : (
                      <>
                        <div className="mb-3">
                          <label className="w-100 mb-3 text-white text-center">
                            {t("Upload your national ID for verification")}{" "}
                          </label>
                          {userdata?.identity_status === 3 ? (
                            <p className="w-100 mb-3" style={{ color: "red" }}>
                              Your document verification has been declined.Please try
                              again.
                            </p>
                          ) : (
                            ""
                          )}
                          {userdata?.user_source &&
                            typeof userdata?.user_source === "string" && (
                              <div className="documentsImageUploaded">
                              <img
                                // style={{
                                //   width: "50px",
                                //   height: "60px",
                                //   objectFit: "cover",
                                // }}
                                src={
                                  userdata?.user_source
                                    ? process.env.REACT_APP_IMAGE_URL +
                                      userdata?.user_source
                                    : user
                                }
                                alt={user}
                              />
                              </div>
                            )}
                          <input
                            type="file"
                            name="file"
                            onChange={(e) => uploadimage(e, "user_source")}
                            class="form-control"
                            style={{ lineHeight: "1.9" }}
                          />
                        </div>
                        {capturedImage === null && userdata?.user_source ? (
                          <>
                            <button className="btn bg_btn m-auto" onClick={startCamera}>
                              {t("Please take your selfie to match")}
                            </button>
                            <div style={{ marginTop: "15px" }}>
                              <video
                                ref={videoRef}
                                width="300"
                                height="200"
                                autoPlay
                                muted
                                playsInline
                              />
                            </div>
                            {checkopencamara && (
                              <button
                                className="btn bg_btn m-auto"
                                onClick={capturePhoto}
                                style={{ marginTop: "10px" }}
                              >
                                {t("Capture Photo & Verify")}
                              </button>
                            )}
                          </>
                        ) : (
                          imageloader?.loading1 && (
                          <div className="DocumentsVerificationLoading">
                            <div
                              className="spinner-border text-primary"
                              role="status"
                            >
                              
                              <span className="visually-hidden">
                                {t("Loading...")}
                              </span>
                            </div>
                          </div>
                          )
                        )}

                        <canvas ref={canvasRef} style={{ display: "none" }} />

                        {capturedImage && (
                          <div style={{ marginTop: "20px" }}>
                            <h4>{t("Captured Image")}:</h4>
                            <img
                              style={{
                                width: "280px",
                                height: "200px",
                                objectFit: "cover",
                              }}
                              src={capturedImage}
                              alt="Captured"
                              width="300"
                            />
                          </div>
                        )}

                        {verificationResult ? (
                          <div style={{ marginTop: "20px" }}>
                            <h4>{t("Verification Result")}:</h4>
                            {verificationResult.error ? (
                              <p style={{ color: "yellow", textAlign: "center" }}>
                                {verificationResult.error}
                              </p>
                            ) : (
                              <>
                                <p>
                                  {" "}
                                  {verificationResult.verified ? (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 24 24"
                                      width="24"
                                      height="24"
                                      fill="rgba(100,205,138,1)"
                                    >
                                      <path d="M11.602 13.7599L13.014 15.1719L21.4795 6.7063L22.8938 8.12051L13.014 18.0003L6.65 11.6363L8.06421 10.2221L10.189 12.3469L11.6025 13.7594L11.602 13.7599ZM11.6037 10.9322L16.5563 5.97949L17.9666 7.38977L13.014 12.3424L11.6037 10.9322ZM8.77698 16.5873L7.36396 18.0003L1 11.6363L2.41421 10.2221L3.82723 11.6352L3.82604 11.6363L8.77698 16.5873Z"></path>
                                    </svg>
                                  ) : (
                                    <button
                                      className="btn bg_btn m-auto"
                                      onClick={startCamera}
                                    >
                                      Selfie did not match. Please try again.
                                    </button>
                                  )}
                                </p>
                              </>
                            )}
                          </div>
                        ) : (
                          imageloader?.loading2 && (
                          <div className="DocumentsVerificationLoading">
                            <div
                              className="spinner-border text-primary"
                              role="status"
                            >
                              
                              <span className="visually-hidden">
                                {t("Loading...")}
                              </span>
                            </div>
                          </div>
                          )
                        )}
                      </>
                    )
                  
                ) :
                  userdata?.user_source && userdata?.user_target ? (
                    <>
                      <p style={{ color: "yellow", textAlign: "center" }}>
                        Verification is pending. Please wait for the confirmation
                        email.
                      </p>
                    </>
                  ) : (
                    <p style={{ color: "red", textAlign: "center" }}>
                      Webcam not found on this device.
                    </p>
                  )} 
                  {error && <p style={{ color: "red", textAlign: "center" }}>{error}</p>}
                </>
            ) : (
                ""
              )} 
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Userverify;
